import React from 'react';

// Components
import { PythonDoc } from "components/api";

export function Config({ children }){
  return <PythonDoc.Content name={"pyhectiqlab.Config"}>
          {children}
          </PythonDoc.Content>
}

export function ConfigInit(){
  const params = [
  {name: "**kwargs", description:"Any type of iterable parameter"}]
  return <div>
          <PythonDoc.Head prefix="class" name="Config" description="Initialize a configuration object. Returns a Config. " params={params}/>
          <PythonDoc.Params params={params}/>
         </div>
}

export function ConfigFromDict(){
  const params = [
  {name: "data", type: "dict", description:"A dictionary object with the data"}]
  return <div>
          <PythonDoc.Head prefix="@classmethod" name="Config.from_dict" description="Initialize a configuration object with the content of a dictionary. Returns a Config. " params={params}/>
          <PythonDoc.Params params={params}/>
         </div>
}

export function ConfigDownload(){
  const params = [
  {name: "run", type: "str", description:"The slugified run name"},
  {name: "project", type: "str", description:"The project name"},
  ]
  return <div>
          <PythonDoc.Head prefix="@staticmethod" name="Config.download" params={params}>
             Download the config object and the meta informations from an existing run. Returns a tuple with the <code>(Config, dict)</code> 
          </PythonDoc.Head>
          <PythonDoc.Params params={params}/>
         </div>
}

export function ConfigLock(){

  return <div>
          <PythonDoc.Head name="Config.lock" params={[]}>
            Disable the settings attributes. The config becomes immuable.
          </PythonDoc.Head>
         </div>
}

export function ConfigUnLock(){

  return <div>
          <PythonDoc.Head name="Config.unlock" params={[]}>
            Enable settings the attributes. The config becomes muable.
          </PythonDoc.Head>
         </div>
}

export function ConfigSave(){
    const params = [
  {name: "path", type: "str", description:"Local path to the config dump."},
  ]
  return <div>
          <PythonDoc.Head name="Config.save" params={params}>
            Write the config in a json format on your local drive.
          </PythonDoc.Head>
          <PythonDoc.Params params={params}/>

         </div>
}

export function ConfigLoad(){
    const params = [
  {name: "path", type: "str", description:"Local path to the config dump."},
  ]
  return <div>
          <PythonDoc.Head prefix="@classmethod" name="Config.load" params={params}>
            Load the config from a json format on your machine. Returns a <code>Config</code> object.
          </PythonDoc.Head>
          <PythonDoc.Params params={params}/>

         </div>
}
